import styled from '@emotion/styled';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

/**
 * A MUI <Tooltip> with custom styles
 */
const ExinMuiTooltip = styled(Tooltip)`
  .${tooltipClasses.tooltip} {
    font-size: 0.875rem;
  }
`;

export default ExinMuiTooltip;
